export const BowlingStyle = {
  RIGHT_ARM_FAST: 'RIGHT_ARM_FAST',
  RIGHT_ARM_MEDIUM: 'RIGHT_ARM_MEDIUM',
  RIGHT_ARM_SPIN: 'RIGHT_ARM_SPIN',
  LEFT_ARM_FAST: 'LEFT_ARM_FAST',
  LEFT_ARM_MEDIUM: 'LEFT_ARM_MEDIUM',
  LEFT_ARM_SPIN: 'LEFT_ARM_SPIN',
  RIGHT_ARM_OFF_BREAK: 'RIGHT_ARM_OFF_BREAK',
  LEFT_ARM_FAST_MEDIUM: 'LEFT_ARM_FAST_MEDIUM',
  RIGHT_ARM_FAST_MEDIUM: 'RIGHT_ARM_FAST_MEDIUM',
  LEFT_ARM_ORTHODOX: 'LEFT_ARM_ORTHODOX',
  RIGHT_ARM_MEDIUM_FAST: 'RIGHT_ARM_MEDIUM_FAST',
  RIGHT_ARM_OFF_SPIN: 'RIGHT_ARM_OFF_SPIN',
  RIGHT_ARM_LEG_SPIN: 'RIGHT_ARM_LEG_SPIN',
  AMBIDEXTROUS_BOWLING: 'AMBIDEXTROUS_BOWLING',
  LEFT_ARM_CHINAMAN: 'LEFT_ARM_CHINAMAN',
  RIGHT_ARM_CHINAMAN: 'RIGHT_ARM_CHINAMAN',
  LEFT_ARM_MEDIUM_FAST: 'LEFT_ARM_MEDIUM_FAST',
  SLOW_BOWLER: 'SLOW_BOWLER',
  NA: 'NA'
} as const;
export type BowlingStyle = typeof BowlingStyle[keyof typeof BowlingStyle];

export const BattingStyle = {
  RIGHT_HANDED: 'RIGHT_HANDED',
  LEFT_HANDED: 'LEFT_HANDED'
} as const;
export type BattingStyle = typeof BattingStyle[keyof typeof BattingStyle];

export const PlayerRole = {
  BATSMAN: 'BATSMAN',
  BOWLER: 'BOWLER',
  WICKET_KEEPER: 'WICKET_KEEPER',
  ALL_ROUNDER: 'ALL_ROUNDER',
  BAT_ALL_ROUNDER: 'BAT_ALL_ROUNDER',
  BOWLING_ALL_ROUNDER: 'BOWLING_ALL_ROUNDER'
} as const;
export type PlayerRole = typeof PlayerRole[keyof typeof PlayerRole];

export const PaymentFrequency = {
  HOUR: 'HOUR',
  TOURNAMENT: 'TOURNAMENT',
  MATCH: 'MATCH',
  MONTHLY: 'MONTHLY'
} as const;
export type PaymentFrequency = typeof PaymentFrequency[keyof typeof PaymentFrequency];

export const Gender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  OTHER: 'OTHER'
} as const;
export type Gender = typeof Gender[keyof typeof Gender];

export const PlayerProfileStatus = {
  CREATED: 'CREATED',
  UPDATED: 'UPDATED',
  PARTIALLY_UPDATED: 'PARTIALLY_UPDATED',
  COMPLETED: 'COMPLETED'
} as const;
export type PlayerProfileStatus = typeof PlayerProfileStatus[keyof typeof PlayerProfileStatus];

export const RelationType = {
  FATHER: 'FATHER',
  MOTHER: 'MOTHER',
  BROTHER: 'BROTHER',
  SISTER: 'SISTER',
  FRIEND: 'FRIEND',
  SPOUSE: 'SPOUSE',
  SON: 'SON',
  DAUGHTER: 'DAUGHTER',
  OTHER: 'OTHER'
} as const;
export type RelationType = typeof RelationType[keyof typeof RelationType];
